export default class ConsultCalendarCtrl {

  constructor ($scope, WorkPlanSrv, UserInfoConstant, $timeout, calendarConfig, moment, WorkPlanModalSrv, $cookies, $mdDialog, GlobalConfig, Requests, $sessionStorage) {
    var consultCalendarVm = this

    // modals
    consultCalendarVm.getGeneralsWorkplan = getGeneralsWorkplan
    consultCalendarVm.active = GlobalConfig.generals.active
    consultCalendarVm.notActive = GlobalConfig.generals.notActive
    consultCalendarVm.planningFinish = true
    consultCalendarVm.inReview = 0
    consultCalendarVm.feedback = 0
    consultCalendarVm.bitacora = bitacora
    consultCalendarVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    consultCalendarVm.$sessionStorage = $sessionStorage

    const currentUser = JSON.parse($cookies.get('currentUser'))
    const SEARCH_PARAMS = {
      teacherId: currentUser.teacherId,
      workplanId: currentUser.workplanId,
      scheduleTypeId: 1
    }

    consultCalendarVm.calendarList = []

    var vm = this
    calendarConfig.displayAllMonthEvents = true
    moment.locale('es')
    vm.calendarView = 'week'
    vm.viewDate = new Date()
    vm.showSections = false
    // vm.id_simulacion     = 0
    vm.level = ''
    vm.error = error
    vm.cancel = cancel
    vm.showCalendar = true
    vm.showTimes = true
    vm.dayViewSplit = 30
    vm.eventSources = []
    vm.$scope = $scope
    vm.WEEKS = []
    calendarConfig.dateFormatter = 'moment' // use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.
    calendarConfig.allDateFormats.moment.date.hour = 'HH:mm' // this will configure times on the day view to display in 24 hour format rather than the default of 12 hour
    calendarConfig.allDateFormats.moment.title.day = 'ddd D MMM' // this will configure the day view title to be shorter
    calendarConfig.i18nStrings.weekNumber = 'Week {week}' // This will set the week number hover label on the month view
    calendarConfig.displayAllMonthEvents = true // This will display all events on a month view even if they're not in the current month. Default false.
    calendarConfig.showTimesOnWeekView = true // Make the week view more like the day view, with the caveat that event end times are ignored.
    vm.headerCalendar = {
      TIME_MODULE: 29,
      START_MODULE: '00:00',
      END_MODULE: '23:59'
    }
    let dates = {
      'Lunes': '2017-05-01 ',
      'Martes': '2017-05-02 ',
      'Miércoles': '2017-05-03 ',
      'Jueves': '2017-05-04 ',
      'Viernes': '2017-05-05 ',
      'Sábado': '2017-05-06 ',
      'Domingo': '2017-05-07 '
    }

    vm.viewChangeClicked = function (date, nextView) {
      return false
    }

    $scope.pageChanged = function () {
      $scope.uiConfig = {}
    }

    function error () {
    }

    function cancel () {
    }

    function showCalendar () {
      vm.showCalendar = true
      vm.viewDate = moment('2017-05-01').toDate()
      vm.showCalendarResults = true
      vm.calendarView = 'week'
    }

    function calendarStudentAttention () {
      if (consultCalendarVm.feedback && !consultCalendarVm.planningFinish) {
        getSchedulesReviewedReject()
      } else {
        getSchedules()
      }
    }

    function getSchedules (header) {
      WorkPlanSrv.getSchedules.getList(SEARCH_PARAMS).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          consultCalendarVm.calendarList = dataReturn.data
          setEvents(consultCalendarVm.calendarList)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function getSchedulesReviewedReject (header) {
      WorkPlanSrv.getActivityCalendarReviewedRejectById.getList(SEARCH_PARAMS).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          consultCalendarVm.calendarList = dataReturn.data
          setEvents(consultCalendarVm.calendarList)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function setEvents (calendarList) {
      vm.eventSources = []
      for (let i in calendarList) {
        let days = calendarList[i].daysNames.split(',')
        for (let x in days) {
          let event = {}
          event.calendarEventId = x + 1
          event.title = calendarList[i].scheduleTypeName
          event.cssClass = 'bg-green-web-planner'
          event.cssClassLetra = 'text-azul-planner'
          event.draggable = false
          event.resizable = false
          event.startsAt = moment(dates[days[x]] + calendarList[i].startHour).toDate()
          event.endsAt = moment(dates[days[x]] + calendarList[i].endHour).toDate()
          event.height = getEventHeight(event.startsAt, event.endsAt)
          vm.eventSources.push(event)
        }
      }
      showCalendar()
    }

    function getEventHeight (startDate, endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      let diff = endDate.diff(startDate, 'minutes')
      diff = Math.round(diff / 30)
      return 30 * diff
    }

    activate()

    function activate () {
      let post = {
        teacherId: currentUser.teacherId,
        workplanId: currentUser.workplanId
      }
      if(consultCalendarVm.workPlanGeneralList != undefined){
        consultCalendarVm.status = consultCalendarVm.workPlanGeneralList.wokplanTeacherStatus[0]
        consultCalendarVm.stages = consultCalendarVm.workPlanGeneralList.stages
        consultCalendarVm.inReview = consultCalendarVm.status.reviewed
        consultCalendarVm.feedback = consultCalendarVm.status.feedbackReviewed
        consultCalendarVm.workplanTeacherId = consultCalendarVm.status.workplanTeacherId
        isPlanning(consultCalendarVm.status, consultCalendarVm.stages)
        
        calendarStudentAttention()
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          calendarStudentAttention()
        })
      }
    }

    function getGeneralsWorkplan (post) {
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          consultCalendarVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          consultCalendarVm.status = dataReturn.data.wokplanTeacherStatus[0]
          consultCalendarVm.stages = dataReturn.data.stages
          consultCalendarVm.inReview = consultCalendarVm.status.reviewed
          consultCalendarVm.feedback = consultCalendarVm.status.feedbackReviewed
          consultCalendarVm.workplanTeacherId = consultCalendarVm.status.workplanTeacherId
          isPlanning(consultCalendarVm.status, consultCalendarVm.stages)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function isPlanning (status, stages) {
      consultCalendarVm.currentDate = moment(new Date()).format('DD/MM/YYYY')
      for (var i = stages.length - 1; i >= 0; i--) {
        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
          consultCalendarVm.startDateStage = stages[i].startDate
        }
      }
      if(status.workplanActive){
        if (status.planningFinish == consultCalendarVm.active) {
          consultCalendarVm.planningFinish = true
          if (consultCalendarVm.startDateReview < consultCalendarVm.currentDate || status.reviewedFinish == consultCalendarVm.active) {
            consultCalendarVm.planningFinish = true
          } else if (status.reviewedReject == consultCalendarVm.active) {
            consultCalendarVm.planningFinish = false
          }
        } else {
          consultCalendarVm.planningFinish = false
        }
      }else{
        consultCalendarVm.planningFinish = true
      }
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.studentAttention,
        workplanTeacherId: consultCalendarVm.workplanTeacherId
      }
      entries.title = 'Atención a estudiantes'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }
  }
}

ConsultCalendarCtrl.$inject = ['$scope', 'WorkPlanSrv', 'UserInfoConstant', '$timeout', 'calendarConfig', 'moment', 'WorkPlanModalSrv', '$cookies', '$mdDialog', 'GlobalConfig', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/studentAttention/consultCalendar/consultCalendarCtrl.js